import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import type { ErrorComponentProps } from "@tanstack/react-router";
import { useEffect } from "react";
import { Button } from "./ui/button";

/**
 * Route-level error boundary. Without one, a single throwing component blanks
 * the whole SPA — there is no server-rendered page to fall back to.
 */
export function ErrorState({ error, reset }: ErrorComponentProps) {
  const queryErrorReset = useQueryErrorResetBoundary();

  useEffect(() => {
    queryErrorReset.reset();
  }, [queryErrorReset]);

  return (
    <div className="mx-auto max-w-md space-y-4 p-4 text-center md:p-8">
      <h2 className="font-semibold text-lg">Etwas ist schiefgelaufen</h2>
      <p className="text-muted-foreground text-sm">{error.message}</p>
      <Button
        onClick={() => {
          queryErrorReset.reset();
          reset();
        }}
      >
        Erneut versuchen
      </Button>
    </div>
  );
}
